import { userAccountInfo } from 'helpers/user'
import { onLogout } from 'redux/loginInfo/loginInfoSlice'
import { useAppDispatch } from 'redux/hooks'

const useLogout = () => {
  const dispatch = useAppDispatch()
  return (): void => {
    userAccountInfo.accountDetail = {
      'cipher.accountId': '',
      'cipher.partialAccountId': '',
      switchAccountType: 'SELF'
    }
    userAccountInfo.accountType = 'generic'
    userAccountInfo.cardType = ''
    userAccountInfo.trackingID = ''
    dispatch(onLogout())
    sessionStorage.clear()
  }
}

export default useLogout
